<template>
  <div
    v-show="styles_loaded && setbrandid"
    :class="setbrandid"
    :style="new_style_variables"
  >
    <Header
      :key="updateHeader"
      :logo_link="logo_link"
      :home_link="home_link"
      :header_menu="header_menu"
      :show_basket="show_basket"
      :show_home="true"
      :show_languages="true"
      :basket_number="basket_items_number"
      :logo_image="logo_image"
      @toggleBasket="toggleBasket"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
      :basket_is_model="true"
      :basket_is_model_and_page="`upsell`"
    ></Header>

    <div class="page-bg" :style="set_style_variables">
      <div class="yourdetails-banner-container">
        <YourDetailsBanner
          :headline="getrans(banner_headline)"
          :headline_mobile="getrans(banner_headline_mobile)"
          :subheadline="''"
          edit-label="Edit"
          :key="getrans(banner_headline_mobile)"
        >
        </YourDetailsBanner>
      </div>

      <div class="page-content">
        <div
          class="page-content__form"
          :class="showing_basket ? 'page-content__hide-section-on-mobile' : ''"
        >
          <template
            v-if="
              result_selected_style === 'list' &&
              dataloaded &&
              dataloaded_carparkdetails
            "
          >
            <!-- {{num_of_crosssells}} -->
            <CrossSellResultsLNG
              v-if="crosssell_data && crosssell_product_show_condition.lng"
              :num_of_crosssells="num_of_crosssells"
              :crosssell_data_passed="crosssell_data"
              @loading_results_finished="loading_results_finished"
            />
            <CrossSellResultsFTT
              v-if="crosssell_data && crosssell_product_show_condition.ftt"
              :num_of_crosssells="num_of_crosssells"
              :crosssell_data_passed="crosssell_data"
              @loading_results_finished="loading_results_finished"
            />

            <div class="results-list"></div>
          </template>
          <div
            class="results-continue hide-section-on-desktop"
            v-if="loading_results_number > 0"
          >
            <button
              v-if="
                (lounge_cartitem && crosssell_product_show_condition.lng) ||
                (fasttrack_cartitem && crosssell_product_show_condition.ftt)
              "
              class="results-continue__button"
              @click="gotoPage('/yourdetails.html')"
            >
              {{ getrans("Continue") }}
            </button>
            <button
              v-else
              class="results-continue__button"
              @click="gotoPage('/yourdetails.html')"
            >
              {{ getrans("Continue without extras") }}
            </button>
          </div>
        </div>
        <div
          class="page-content__basket"
          v-if="cartloaded"
          :class="showing_basket ? '' : 'page-content__hide-section-on-mobile'"
        >
          <div
            class="
              page-content__basket-subtotal page-content__basket--box-style
            "
          >
            <span
              v-if="setbrandid == 'RDU' || setbrandid == 'YHM'"
              class="page-content__form-title"
              >{{ getrans("Cart Subtotal") }}:</span
            >
            <span v-else class="page-content__form-title"
              >{{ getrans("Basket Subtotal") }}:</span
            >
            <span
              class="page-content__form-title page-content__form-title--price"
              >{{ currency }}
              {{
                parseFloat(finaltotalvalue).toFixed(2) ||
                parseFloat(cartitem.price).toFixed(2)
              }}
            </span>
            <template v-if="setbrandid === 'HVN'">
              <p>
                Includes 6.35% state sales tax.
              </p>
            </template>
            <button style="width: 100%" @click="toggleBasket()">
              {{ getrans("Click to proceed") }}
            </button>
          </div>

          <BasketItem
          :showtaxes_action="showtaxes_action"
            v-on:finaltotalvalueChange="finaltotalvalueChange"
            v-on:basketItemsNumber="basketItemsNumber"
            :prop_parking_cartitem="cartitem"
            :item_price="cartitem ? cartitem.price : undefined"
            :item_title="cartitem ? cartitem.carpark_name : undefined"
            :item_start_date="
              cartitem ? formatDatedmy(cartitem.valid_from) : undefined
            "
            :item_start_time="cartitem ? cartitem.start_time : undefined"
            :item_end_date="
              cartitem ? formatDatedmy(cartitem.valid_till) : undefined
            "
            :item_end_time="cartitem ? cartitem.end_time : undefined"
            :prop_fasttrack_cartitem="fasttrack_cartitem"
            :remove_fasttrack_cartitem="update_fasttrack_cartitem"
            :prop_lounge_cartitem="lounge_cartitem"
            :remove_lounge_cartitem="update_lounge_cartitem"
            :update_cart_items="update_cart_items"
            :lang="lang.toUpperCase()"
            :translations="translations"
            :brandSlug="brandSlug"
          />

          <div
            v-if="
              !(lounge_cartitem && crosssell_product_show_condition.lng) &&
              !(fasttrack_cartitem && crosssell_product_show_condition.ftt)
            "
          >
            <button
              class="results-continue__button"
              @click="gotoPage('/yourdetails.html')"
            >
              {{ getrans("Continue without extras") }}
            </button>
          </div>
          <div
            v-else
          >
            <button
              class="results-continue__button"
              @click="gotoPage('/yourdetails.html')"
            >
              {{ getrans("Continue") }}
            </button>
          </div>

        </div>
      </div>
    </div>

    <div class="faq-section" v-if="false">
      <div class="faq-section-title">
        <h3 class="faq-title">
          {{ getrans("Frequently asked questions...") }}
        </h3>
      </div>
      <div class="faq-section-inner">
        <div class="faq-section-inner-block">
          <h4 class="faq-title">
            {{ getrans("Can I change or cancel my booking?") }}
          </h4>
          <p>
            {{
              getrans(
                "This depends on the product you purchase. Supersaver products cannot be amended or cancelled. All other products can be amended or cancelled up to 24 hours before your car park entry time. You can do this in the Manage My Booking facility on our online booking site."
              )
            }}
          </p>
        </div>
        <div class="faq-section-inner-block">
          <h4 class="faq-title">
            {{ getrans("Can I change a registration number after booking?") }}
          </h4>
          <p>
            {{
              getrans(
                "Yes you can change the registration number up to 24 hours before your car park entry time. You can do this in the Manage My Booking facility on our online booking site."
              )
            }}
          </p>
        </div>
        <div class="faq-section-inner-block">
          <h4 class="faq-title">
            {{ getrans("Read more in our FAQ section") }}
          </h4>
          <p>
            {{
              getrans(
                "For help and support with any of your pre-travel or after travel queries browse through our frequently asked questions."
              )
            }}
          </p>
        </div>
      </div>
    </div>

    <Footernwi
      v-if="setbrandid === 'NWI'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footernwi>
    <Footer
      v-else
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footer>
    <!-- <LoginModel /> -->
    <BasketModel
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></BasketModel>

    <Cookies :brandSlug="setbrandid" :translations="translations"/>
    <CookiesOld :brandSlug="setbrandid" v-if="setbrandid === 'none'" />
  </div>
</template>

<script>
const axios = require("axios");
const genkeys = require("rezauthlib");
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import Footernwi from "../../components/FooterNWI.vue";
import YourDetailsBanner from "../../components/YourDetailsBanner.vue";
import BasketItem from "../../components/BasketItem.vue";
//import ResultsBanner from "../../components/ResultsBanner.vue";

//import ResultsList from "../../components/ResultsListupsell.vue";
//import ResultsMobile from "../../components/ResultsMobileupsell.vue";
import BasketModel from "../../components/BasketModel.vue";

import CrossSellResultsLNG from "../../components/CrossSellResultsLNG.vue";
import CrossSellResultsFTT from "../../components/CrossSellResultsFTT.vue";

//import SearchWidget from "../../components/SearchWidgetCustomElement.vue";
import Cookies from "../../components/Cookies.vue";
import CookiesOld from "../../components/Cookies_old.vue";
//const { EncryptStorage } = require("encrypt-storage");
//const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {storageType: 'sessionStorage',});

/* eslint-disable */
import en from "date-format-parse/lib/locale/en";
import el from "date-format-parse/lib/locale/el";
import de from "date-format-parse/lib/locale/de";
import fr from "date-format-parse/lib/locale/fr";
import es from "date-format-parse/lib/locale/es";
import pt from "date-format-parse/lib/locale/pt";
/* eslint-enable */

console.log(el);

import { reactive } from "vue";

import md5 from "js-md5";
const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});

const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

import { set_style_vars } from "@/modules/set_style_vars";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Footernwi,
    YourDetailsBanner,
    BasketItem,
    BasketModel,
    //ResultsBanner,
    //ResultsList,
    // ResultsMobile,
    //SearchWidget,
    CrossSellResultsLNG,
    CrossSellResultsFTT,
    Cookies,
    CookiesOld,
  },
  data() {
    return {
      showtaxes_action:true,
      basket_refresh: 0,
      cartloaded: false,
      finaltotalvalue: false,
      basket_items_number: 0,
      cartitem: {},
      cartitem_park: {},
      fasttrack_cartitem: {},
      lounge_cartitem: {},
      banner_headline: "Travel Extras",
      banner_headline_mobile: "Travel Extras",
      crosssell_data: "",
      styles_loaded: false,
      lang: "en",
      translations: "",
      setbrandid: "",
      currency: "",
      date1_forwidget: "",
      date2_forwidget: "",
      date1_date: "",
      date1_time: "",
      date2_date: "",
      date2_time: "",
      searchres: [],
      venue_select: "",
      venue_select_name: "",
      carparkdetails: [],
      brandloaded: false,
      dataloaded: false,
      dataloaded_carparkdetails: false,
      widgetloaded: false,
      css_data: undefined,
      results_headline: "Official Airport Parking",
      results_subheadline: "",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_styles: reactive({}),
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "1.5rem",
      hero_font_size_h1_mobile: "1.3rem",
      hero_font_size_p: "1.3rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Columns",
      show_basket: false,
      result_selected_style: "list",
      result_selected_order: "closest",
      showSearchWidget: false,
      noSlotsAvailable: false,
      neworder: false,
      neworder_key: 0,
      closeest_cheapest: "closest",
      searchres_filtered: {},
      nonVisableMessage: false,
      prdiffmin: 0,
      crosssell_product_show_condition: { lng: false, ftt: false },
      num_of_crosssells: 0,
      loading_results_number: 0,
      updateHeader: 0,
    };
  },
  computed: {
    new_style_variables() {
      return set_style_vars(this.brand_product_styles, "results");
    },
    set_style_variables: function () {
      return {
        "--hero-background-mobile": `url(${this.hero_desktop_background})`,
        "--hero-background-desktop": this.hero_mobile_background
          ? `url(${this.hero_mobile_background})`
          : `url(${this.hero_desktop_background})`,
        "--hero-font-size-h1": this.hero_font_size_h1,
        "--hero-font-size-h1-mobile": this.hero_font_size_h1_mobile,
        "--hero-font-size-p": this.hero_font_size_p,
        "--hero-font-size-p-mobile": this.hero_font_size_p_mobile,
        "--hero-text-align": this.hero_text_align,
        "--hero-text-align-mobile":
          this.hero_text_align_mobile || this.hero_text_align,
        "--panel-background-color": this.panels_background_color,
      };
    },
  },
  methods: {
    loading_results_finished() {
      this.loading_results_number++;

      console.log("loading_results_number", this.loading_results_number);
      console.log("num_of_crosssells", this.num_of_crosssells);
      //console.log('loading_results_finished', e);
    },
    update_fasttrack_cartitem() {
      this.fasttrack_cartitem = encryptStorage.getItem("fasttrack_cart");
    },
    update_lounge_cartitem() {
      this.lounge_cartitem = encryptStorage.getItem("lounge_cart");
    },
    update_cart_items() {
      this.cartitem = encryptStorage.getItem("cart");
      this.updateHeader++;
    },
    gotoPage(url, type = null) {
      if (url.indexOf("myaccountdev.") > -1 && this.lang) {
        url += "?lang=" + this.lang;
      }
      if (url.indexOf("myaccount.") > -1 && this.lang) {
        url += "?lang=" + this.lang;
      }
      if (type && type.toLowerCase() === "external") {
        window.open(url);
      } else {
        window.location.href = url;
      }
    },
    formatDatedmy(date) {
      if (typeof date !== "undefined") {
        date = date.split("/");
        date = date[2] + "/" + date[1] + "/" + date[0];
        return date;
      } else {
        return "";
      }
    },
    finaltotalvalueChange(value) {
      this.finaltotalvalue = value;
    },
    basketItemsNumber(value) {
      this.basket_items_number = value;
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      console.log("getrans results", string, ss);
      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    loadTranslations() {
      let vm = this;
      if (vm.getSessionData("language")) {
        vm.lang = vm.getSessionData("language");
      } else {
        if (process.env.VUE_APP_DEFAULT_LANG_DE && JSON.parse(process.env.VUE_APP_DEFAULT_LANG_DE).includes(this.setbrandid)) {
          vm.lang = 'de';
        }
        vm.setSessionData("language", vm.lang);
      }

      const urlParams = new URLSearchParams(window.location.search);
      let param_lang = urlParams.get("lang");
      if (param_lang) {
        vm.lang = param_lang;
        vm.setSessionData("language", vm.lang);
      }

      console.log(vm.getSessionData("language"));
      console.log("vm.lang");

      console.log(this.lang);

      store.getItem("tranlations").then((params) => {
        if (params !== null) {
          vm.translations = JSON.parse(params);
          console.log("getTranscache");
          console.log(vm.translations);
        } else {
          axios
            .get(
              "https://devhub.rezcomm.com/hubapmydbauth/brandapi/devtrans.php?brandslug=" +
                vm.setbrandid
            )
            .then((response) => {
              console.log("getTranscache");
              console.log(response);
              vm.translations = JSON.parse(response.request.response);
              store.setItem("tranlations", JSON.stringify(vm.translations));
            });
        }
      });
    },

    put(key, value, obj) {
      obj[key] = value;
      return obj;
    },
    setListStyle(type) {
      this.result_selected_style = type;
    },

    sortByDistancePrice() {
      /* eslint-disable */
      this.searchres_filtered = {};
      for (let j = 0; j < this.searchres.length; j++) {
        for (let i = 0; i < this.neworder.length; i++) {
          if (
            this.searchres[j].carpark_id &&
            this.searchres[j].carpark_id === this.neworder[i]
          ) {
            this.searchres_filtered[i] = this.searchres[j];
          }
        }
      }
      /* eslint-enable */
    },

    setNonVisableMessage() {
      let num_of_visable = 0;
      //let not_visible_count  = 0;
      for (let j = 0; j < this.searchres.length; j++) {
        console.log("test", j);
        console.log("this.searchres_filtered", j, this.searchres[j]);
        if (this.searchres[j].visible) {
          num_of_visable++;
        }
      }
      console.log("num_of_visable", num_of_visable);
      console.log("this.searchres.length", this.searchres.length);
      if (Number(num_of_visable) === Number(this.searchres.length)) {
        this.nonVisableMessage = true;
      } else {
        this.nonVisableMessage = false;
      }
    },

    setListOrder(type) {
      if (!this.carparkdetails && !this.carparkdetails.clients) {
        return false;
      }
      if (
        this.carparkdetails.clients === "null" ||
        this.carparkdetails.clients === undefined
      ) {
        return null;
      }

      if (type === "closest") {
        this.closeest_cheapest = "closest";
        this.result_selected_order = type;
        let obj = Object.values(this.carparkdetails.clients);
        let neworder = obj.sort(function (a, b) {
          if (b.distance_order) {
            return a.distance_order - b.distance_order;
          }
        });
        let newobj = [];
        for (let i = 0; i < neworder.length; i++) {
          newobj.push(neworder[i].carpark_id);
        }
        this.neworder = newobj;
        this.neworder_key++;
      }

      if (type === "cheapest") {
        this.closeest_cheapest = "cheapest";

        this.result_selected_order = type;
        let obj = Object.values(this.searchres);
        console.log(obj);

        let neworder = obj.sort(function (a, b) {
          if (b.grand_total) {
            return a.grand_total - b.grand_total;
          }
        });
        let newobj = [];
        for (let i = 0; i < neworder.length; i++) {
          newobj.push(neworder[i].carpark_id);
        }
        this.neworder = newobj;
        this.neworder_key++;
      }

      //this.sortByDistancePrice();
      //this.setNonVisableMessage();
    },
    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      this.setStyles(this.brand_data.brand_product_styles);
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;
    },
    getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;
        console.log("uidgen", uidgen);

        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/brandapi/branddetailsdev.php?brandslug=" +
              this.setbrandid,
            "",
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log(response.data);
            this.setLocalData("brand_data", response.data);
            this.setMenu(response.data);
            this.createPanels(response.data);
            this.setBrandData();
          });
      }
    },
    setStyles(obj) {
      /* eslint-disable */
      obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      console.log(this.brand_product_styles["asset_image_1"]);
      this.logo_image = this.brand_product_styles["asset_image_1"];
      this.hero_font_size_h1 =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_h1_mobile =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_p = this.brand_product_styles["panel_text_font_size"];
      this.hero_font_size_p_mobile =
        this.brand_product_styles["panel_text_font_size"];
      /* eslint-enable */
    },
    setMenu(data) {
      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    createPanels(data) {
      let panels_data = data.brand_home_panels || [];
      panels_data.sort((a, b) => (a.rownum > b.rownum ? 1 : -1));
      panels_data = panels_data.reduce((a, r) => {
        if (!a[r.rownum]) a[r.rownum] = { row: r.rownum, columns: [] };
        a[r.rownum].columns.push(r);
        return a;
      }, {});
      this.panels_group = panels_data;
    },
    correctdate(d) {
      if (d) {
        d = d.replace("st", "");
        d = d.replace("nd", "");
        d = d.replace("rd", "");
        d = d.replace("th", "");
        return d;
      }
    },
    formatDateymd(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("/");
    },

    formatTime(timeString) {
      let [hourString, minute] = timeString.split(":");
      let hour = +hourString % 24;
      return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "am" : "pm");
    },

    format_date(date, format_date) {
      const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
      if (date) {
        //console.log(date);
        let dt = new Date(date);
        //let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        let month = months[dt.getMonth()];
        let day =
          dt.getDate() +
          (dt.getDate() % 10 == 1 && dt.getDate() != 11
            ? "st"
            : dt.getDate() % 10 == 2 && dt.getDate() != 12
            ? "nd"
            : dt.getDate() % 10 == 3 && dt.getDate() != 13
            ? "rd"
            : "th");

        let hours = dt.getHours();
        let mins = dt.getMinutes();
        let year = dt.getFullYear();
        let dateString = "";
        if (format_date === "date") {
          dateString = `${month} ${day} ${year}`;
        }
        if (format_date === "time") {
          dateString = `${pad(hours)}:${pad(mins)}`;
        }
        return dateString;
      }
    },

    format_date_with_locale(date, format_date) {
      let use12 = true;
      if (this.setbrandid === "HER") {
        use12 = false;
      }
      const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
      if (date) {
        let language;
        let digits = 2;
        if (this.lang === "en") {
          language = en;
        }
        if (this.lang === "el") {
          language = el;
        }
        if (this.lang === "de") {
          language = de;
        }
        if (this.lang === "fr") {
          language = fr;
        }
        if (this.lang === "es") {
          language = es;
          digits = 3;
        }
        if (this.lang === "pt") {
          language = pt;
          digits = 3;
        }
        let lang_obj;
        if (digits === 2) {
          lang_obj = {
            formatLocale: language,
            yearFormat: "YYYY",
            monthFormat: "MMM",
            monthBeforeYear: true,
          };
        } else if (digits === 3) {
          lang_obj = {
            formatLocale: language,
            yearFormat: "YYYY",
            monthFormat: "MMM",
            days: language.weekdaysShort,
            monthBeforeYear: true,
          };
        }

        console.log("lang_obj");
        console.log(lang_obj);
        let months = lang_obj.formatLocale.monthsShort;

        let dt = new Date(date);

        let month = months[dt.getMonth()];
        let day = dt.getDate() + "";

        if (this.lang === "en") {
          day =
            dt.getDate() +
            (dt.getDate() % 10 == 1 && dt.getDate() != 11
              ? "st"
              : dt.getDate() % 10 == 2 && dt.getDate() != 12
              ? "nd"
              : dt.getDate() % 10 == 3 && dt.getDate() != 13
              ? "rd"
              : "th");
        }

        let hours = dt.getHours();
        let mins = dt.getMinutes();
        let year = dt.getFullYear();
        let dateString = "";
        if (format_date === "date") {
          dateString = `${month} ${day} ${year}`;
        }
        if (format_date === "time") {
          if (use12) {
            dateString = this.formatTime(`${pad(hours)}:${pad(mins)}`);
          } else {
            dateString = `${pad(hours)}:${pad(mins)}`;
          }
        }
        return dateString;
      }
    },

    getApiData() {
      let dataa = { brand_id: this.setbrandid };
      let secsaa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_CPKDET_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_CPKDET_SECRETKEY
      );
      let b1sa = secsaa.b1s;
      let v2sa = secsaa.v2s;
      let a1a = secsaa.a1;
      let v1a = secsaa.v1;
      let c2sa = secsaa.c2s;
      let uidgena = secsaa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/carparkingservice/carparkdetails.php",
          dataa,
          {
            headers: {
              b1: b1sa,
              v2: v2sa,
              c2s: c2sa,
              a1: a1a,
              v1: v1a,
              c1: uidgena,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          let datasent = JSON.parse(response.request.response);
          this.carparkdetails = datasent;
          console.log("carparkdetails", this.carparkdetails);
          this.dataloaded_carparkdetails = true;
          this.dataloaded = true;
          this.setListOrder("closest");
          this.neworder_key++;
        });
      setTimeout(() => {
        this.widgetloaded = true;
        //sessionStorage.clear();
      }, 0);
    },
    getbranded() {
      var thingy = this;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/getbrnslg_dev.php",
          "",
          {
            headers: {
              secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log(response.data.slug);
          console.log(response.data.currency);
          if (response.data.code == "1") {
            thingy.setbrandid = response.data.slug;
            thingy.currency = response.data.currency;
            if (response.data.slug == "HER" || response.data.slug == "NOC" || response.data.slug == "SZG") {
              thingy.currency = "€";
            }
            thingy.brandloaded = true;
            thingy.loadTranslations();
            thingy.getBrandData();
            this.widgetloaded = true;
            thingy.getApiData();
            let crosssell_data = encryptStorage.getItem("crosssell_data");
            this.crosssell_data = crosssell_data;

            console.log('this.crosssell_data', this.crosssell_data);

            // get wetther lng ftt are suggested here and add conditions
            if (this.crosssell_data && this.crosssell_data.data) {
              this.crosssell_data.data.forEach((item) => {
                this.num_of_crosssells++;
                if (item.suggestion_product_id === "lng" && item.status=='success') {
                  this.crosssell_product_show_condition.lng = true;
                }
                if (item.suggestion_product_id === "ftt" && item.status=='success') {
                  this.crosssell_product_show_condition.ftt = true;
                }
              });
            }

            //this.crosssell_product_show_condition

            // let cc = encryptStorage.getItem("cart");
            // let price = cc.price;
            // let prarray = [];
            // let crosssell_data = encryptStorage.getItem("crosssell_data");
            // this.crosssell_data = crosssell_data;
            // console.log('this.crosssell_data',this.crosssell_data);
            // Object.entries(crosssell_data).forEach((entry) => {
            //   const [key, value] = entry;
            //   if (key == "data") {
            //     Object.entries(value).forEach((entrya) => {
            //       const [keya, valuea] = entrya;
            //       console.log(keya);
            //       prarray.push(
            //         parseFloat(valuea.final_amount) - parseFloat(price)
            //       );
            //     });
            //   }
            // });
            // thingy.prdiffmin = Math.min.apply(null, prarray);
            // thingy.banner_headline =
            //   "Get closer from just " +
            //   thingy.currency +
            //   parseFloat(thingy.prdiffmin).toFixed(2);
            // thingy.banner_headline_mobile =
            //   "Get closer from just " +
            //   thingy.currency +
            //   parseFloat(thingy.prdiffmin).toFixed(2);
          }
        });
    },

    set_results_subheadline() {
      //"11 Dec 2021 at 9:00 am - 11 Dec 2021 at 9:00 am";
      if (this.date1_date && this.date2_date) {
        this.results_subheadline =
          this.format_date_with_locale(this.date1_date, "date") +
          " " +
          this.getrans("at") +
          " " +
          this.format_date_with_locale(
            this.date1_date + " " + this.date1_time,
            "time"
          ) +
          " - " +
          this.format_date_with_locale(this.date2_date, "date") +
          " " +
          this.getrans("at") +
          " " +
          this.format_date_with_locale(
            this.date2_date + " " + this.date2_time,
            "time"
          );
      }
    },

    loadFunction() {
      this.cartitem = encryptStorage.getItem("cart");
      this.cartitem_park = encryptStorage.getItem("cart");
      this.fasttrack_cartitem = encryptStorage.getItem("fasttrack_cart");
      this.lounge_cartitem = encryptStorage.getItem("lounge_cart");

      console.log("this.venue_select");
      console.log(this.venue_select);

      let finprice = 0;
      if (typeof this.cartitem !== "undefined") {
        finprice = finprice + parseFloat(this.cartitem.price);
      } else {
        this.cartitem = {};
      }

      if (typeof this.lounge_cartitem !== "undefined") {
        finprice = finprice + parseFloat(this.lounge_cartitem.loungesubtotal);
      }

      if (typeof this.fasttrack_cartitem !== "undefined") {
        finprice =
          finprice + parseFloat(this.fasttrack_cartitem.fasttracksubtotal);

        /*let object = this.fasttrack_cartitem;
      for (const property in object) {
        console.log(`${property}: ${object[property]}`);

        switch (property) {
          case "ADL":
            for (let i = 0; i < object[property]; i++) {
              this.fasttrack_passengers_ADL.push({
                title: this.getrans("Rather not say"),
                firstname: "Adult " + i,
                surname: "Adult " + i,
              });
            }
            break;
          case "CHD":
            for (let i = 0; i < object[property]; i++) {
              this.fasttrack_passengers_CHD.push({
                title: this.getrans("Rather not say"),
                firstname: "Child " + i,
                surname: "Child " + i,
              });
            }
            break;
          case "INF":
            for (let i = 0; i < object[property]; i++) {
              this.fasttrack_passengers_INF.push({
                title: this.getrans("Rather not say"),
                firstname: "Infant " + i,
                surname: "Infant " + i,
              });
            }
            break;
        }
      }*/

        console.log(
          "this.fasttrack_passengers_ADL",
          this.fasttrack_passengers_ADL
        );
      }
      this.finprice = finprice.toFixed(2);
      console.log("finprice", this.finprice);

      this.cartloaded = true;
    },
  },
  created() {},
  mounted() {
    // Remove the loader once Vue is initialized
    const loader = document.getElementById('loader');
    if (loader) {
      loader.parentNode.removeChild(loader);
    }
    this.getbranded();

    setTimeout(() => {
      //this.getBrandData();
      //sessionStorage.clear();
    }, 0);

    this.loadFunction();

    window.addEventListener("update_basket", () => {
      console.log("basket update");
      this.loadFunction();
      this.basket_refresh++;
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/formStyles.scss";
@import "@/assets/sass/override_brand.scss";
// .tab-basket {
//   display: none !important;
// }

#demoPayButton {
  i {
    display: none;
  }
}

#demoPayButton {
  pointer-events: none;
  filter: grayscale(100%);
  cursor: not-allowed;
}

.cvv-valid.ccnumber-valid.ccexp-valid #demoPayButton {
  pointer-events: all;
  filter: grayscale(0%);
  cursor: pointer;
}

.cvv-valid.ccnumber-valid.ccexp-valid.submit_click #demoPayButton {
  pointer-events: none;
  filter: grayscale(100%);
  i {
    display: inline-block;
  }
}

.cvv-valid.ccnumber-valid.ccexp-valid.submit_click #psp-form {
  pointer-events: none;
}

.CollectJSInlineIframe {
  border: none;
  height: 55px !important;
  border-bottom: 1px solid#dddddd;
}
</style>
<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.standard-para,
.input-checkbox label {
  font-family: var(--details_text_font_family, inherit);
  font-size: var(--details_text_font_size, 1rem);
  font-weight: var(--details_text_font_weight, inherit);
  color: var(--details_text_font_color, #222);
}

.yourdetails-banner-container {
  height: 171px;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  display: flex;
  align-items: center;

  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
  }
}

.page-content {
  // outline: 1px solid red;
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  margin-top: -3.5rem;
  gap: 2rem;
  @media screen and (max-width: 1200px) {
    gap: 1rem;
  }

  @media screen and (min-width: 1100px) {
    grid-template-columns: 2fr 1fr;
  }

  padding: 1rem;
  @media screen and (max-width: 767.98px) {
    padding: 1rem 0;
  }

  &__form {
    // outline: 1px solid green;

    &--box-style {
      background: #ffffff;
      box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #dfdfdf;
      padding: 1em 1.375rem;
      margin-bottom: 2rem;
    }
  }

  &__form-details {
    position: relative;
    // padding: 1em 1rem 1rem 1.375rem;
    // padding-right: calc(1rem - 20px);
  }

  &__form-proceed {
    margin-bottom: 1rem;
    button {
      width: 100%;
      padding: 1em;
      font-family: var(--details_buttons_primary_font_family, inherit);
      font-size: var(--details_buttons_primary_font_size, 1rem);
      font-weight: var(--details_buttons_primary_font_weight, inherit);
      background: var(--details_buttons_primary_background, #034a94);
      color: var(--details_buttons_primary_font_color, #fff);
      border: var(--details_buttons_primary_border, none);
      border-radius: var(--details_buttons_primary_border_radius, 0.25rem);
    }
  }

  &__form-proceed.guest-btn {
    margin-bottom: 1rem;
    button {
      width: 100%;
      padding: 1em;
      font-family: var(--details_buttons_secondary_font_family, inherit);
      font-size: var(--details_buttons_secondary_font_size, 1rem);
      font-weight: var(--details_buttons_secondary_font_weight, inherit);
      background: var(--details_buttons_secondary_background, #e9e7e7);
      color: var(--details_buttons_secondary_font_color, #2f3e52);
      border: var(--details_buttons_secondary_border, none);
      border-radius: var(--details_buttons_secondary_border_radius, 0.25rem);
    }
  }

  &__form-btn {
    width: 100%;
    padding: 1em;
    font-family: var(--details_buttons_primary_font_family, inherit);
    font-size: var(--details_buttons_primary_font_size, 1rem);
    font-weight: var(--details_buttons_primary_font_weight, inherit);
    background: var(--details_buttons_primary_background, #034a94);
    color: var(--details_buttons_primary_font_color, #fff);
    border: var(--details_buttons_primary_border, none);
    border-radius: var(--details_buttons_primary_border_radius, 0.25rem);
  }

  &__form-title {
    clear: both;
    padding: 0.25rem 0 1rem;
    font-family: var(--details_headings_font_family, inherit);
    font-size: var(--details_headings_font_size, 1.25rem);
    font-weight: var(--details_headings_font_weight, bold);
    color: var(--details_headings_font_color, #0a3b74);
  }

  &__basket-subtotal {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .page-content__form-title {
      padding: 0;
    }
    button {
      margin-top: 1rem;
      width: 100%;
      padding: 1em;
      background: #034a94;
      color: #fff;
      border: 0px;
      border-radius: 0.25rem;
      @media screen and (min-width: 768px) {
        display: none;
      }
    }
  }

  &__form-title--price {
    font-size: 1.5rem;
    font-family: var(--basket_price_font_family, inherit);
    font-weight: var(--basket_price_font_weight, bold);
    color: var(--basket_price_font_color, #236ca3);
  }

  &__basket {
    // outline: 1px solid blue;
    @media screen and (min-width: 1100px) {
      display: block;
    }

    &--box-style {
      background: #ffffff;
      box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #dfdfdf;
      padding: 1em 1.375rem;
      margin-bottom: 1rem;
    }
  }

  &__hide-section-on-mobile {
    display: none;
    @media screen and (min-width: 1100px) {
      display: block;
    }
  }


}

.hide-section-on-desktop {
  display: initial;
  @media screen and (min-width: 1100px) {
    display: none;
  }
}

.postcode-message {
  padding: 1rem 0;
  font-size: 0.875rem;
}

.input-checkbox label {
  cursor: default;
}

.fastest-option {
  display: flex;
  justify-content: space-between;

  &__outer {
    display: flex;
    flex-wrap: nowrap;
    align-self: flex-start;
    background-size: cover;
    background-repeat: no-repeat;
    background-position-y: center;
  }

  &__inner {
    height: auto;
    padding: 0.5rem 1.5rem;
    // background: linear-gradient(102deg, #DB9B03 0%, #DF2B1F 100%) 0% 0% no-repeat;
    color: #fff;
    margin-left: 0.5rem;
  }
}

.bolder-text {
  // color: #1a2a40;
  // font-size: 1rem;
  // font-weight: 600;
  font-family: var(--details_subheadings_font_family, inherit);
  font-size: var(--details_subheadings_font_size, 1rem);
  font-weight: var(--details_subheadings_font_weight, 600);
  color: var(--details_subheadings_font_color, #1a2a40);
}

.block-wrap-question-icon--in-title {
  width: auto;
  display: inline;
  float: right;
  padding: 0;
}

.inputs-heading {
  display: block;
}

.passenger-block {
  padding: 1rem;
  padding-bottom: 0rem;
  padding-right: 0rem;
  margin-bottom: 1rem;
  border: 1px solid #eee;
  .inputs-heading {
    font-weight: bold;
    color: #0a3b74;
    padding-bottom: 1rem;
  }
}

.bank-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  padding-bottom: 3rem;
  i {
    color: #0a3b74;
    font-size: 1.5rem;
  }
  img {
    display: block;
    height: 1.6rem;
    width: auto;
  }
}

.custom-checkbox-text {
  color: #444;
  display: block;
  float: left;
  font-size: 0.9rem;
}

.faq-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  h3.faq-title {
    font-family: var(--details_headings_font_family, inherit);
    font-weight: var(--details_headings_font_weight, bold);
    color: var(--details_headings_font_color, #0a3b74);
    font-size: 1.5rem !important;
  }
  h4.faq-title {
    font-family: var(--details_headings_font_family, inherit);
    font-weight: var(--details_headings_font_weight, bold);
    color: var(--details_headings_font_color, #0a3b74);
    font-size: 1.25rem !important;
  }
  &-title {
    padding: 2rem 1rem 0rem 1rem;
    width: 100%;
    max-width: 1300px;
  }
  &-inner {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    @media screen and (max-width: 959px) {
      grid-template-columns: 1fr;
      gap: 1rem;
    }
    width: 100%;
    max-width: 1300px;
    padding: 1rem;
    gap: 2rem;
    &-block {
      background: #fff;
      border: 1px solid #eee;
      box-shadow: 0px 3px 6px #00000029;
      padding: 2rem 2rem 1rem;
      margin-bottom: 2rem;
      @media screen and (max-width: 959px) {
        margin-bottom: 0rem;
        padding: 1.5rem 1.5rem 0.5rem;
      }
    }
    p {
      color: #666666;
    }
  }
}

.results {
  &-filter {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-container {
      height: 54px;
      background-color: #f9f9f9;
      border-bottom: 2px solid var(--header_banner_search_filter_color, #034a94);

      @media screen and (max-width: 768px) {
        display: none;
      }

      a {
        display: inline-block;
        line-height: 52px;
        border: none;
        padding: 0 1.625rem;
        margin: 0;
        background-color: transparent;
        border-right: 1px solid #dfdfdf;
        text-decoration: none;
        color: #000000;

        &:first-child {
          border-left: 1px solid #dfdfdf;
        }

        &:hover,
        &:active,
        &.active {
          background-color: var(--header_banner_search_filter_color, #034a94);
          color: #ffffff;
        }
      }

      button {
        display: inline-block;
        line-height: 52px;
        border: none;
        padding: 0 1.625rem;
        margin: 0;
        background-color: transparent;
        border-right: 1px solid #dfdfdf;
        text-decoration: none;
        color: #000000;

        &:first-child {
          border-left: 1px solid #dfdfdf;
        }

        &:hover,
        &:active,
        &.active {
          background-color: var(--header_banner_search_filter_color, #034a94);
          color: #ffffff;
        }
      }
    }
  }

  &-container {
    margin-top: 3.75rem;
    @media screen and (max-width: 768px) {
      margin-top: 1rem;
    }
  }

  &-grid {
    max-width: 1280px;
    max-width: calc(1280px + 2rem);
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    @media screen and (max-width: 1024px) {
      grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  &-list {
    max-width: calc(1280px + 2rem);
    padding: 0rem;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  &-mobile {
    display: none;
    margin: 0 auto;
    display: none;
    @media screen and (max-width: 768px) {
      display: grid;
      grid-template-columns: 1fr;
    }
  }
}

.results-continue {
  @media screen and (max-width: 768px) {
    padding: 0 1rem;
    margin: 2rem 0 3rem;
  }
  &__button {
    width: 100%;
    background-color: var(--result_button_primary_background, #034a94);
    color: var(--result_button_primary_font_color, #ffffff);
    border-radius: var(--result_button_primary_border_radius, 8px);
    box-shadow: 0px 3px 6px #00000029;
    border: none;
    padding: 0.75rem 1.5rem;
    font-size: 1.325rem;
    font-weight: bold;
    margin-bottom: 4rem;
  }
}
</style>
